export const ACTIVITY_BADGE_CLASSNAME = 'rounded-full px-2.5 py-1 text-xs font-bold';

export const OUTLINE_MISSION_BUTTON_CLASSNAME =
  'inline-flex shrink-0 items-center justify-center gap-2 rounded-full border-2 border-[var(--color-mission)] bg-white px-5 py-2.5 text-sm font-extrabold text-[var(--color-mission)] transition-transform duration-100 active:scale-[0.97] hover:bg-[var(--color-mission)] hover:text-white';

export function activityStatusVariant(status, t) {
  if (status === t('activity.activity_not_submitted')) return 'danger-soft';
  if (status === t('activity.activity_submitted')) return 'success-soft';
  if (status === t('activity.activity_evaluated')) return 'success-soft';
  if (status === t('activity.awaiting_submission')) return 'amber-soft';
  return 'amber-soft';
}

// Status do activity_student na tela de avaliação (ex.: "Avaliação realizada"),
// vocabulário diferente do status usado na listagem/detalhe da atividade.
export function activityStudentStatusVariant(status, t) {
  if (status === t('activity.evaluationCompleted')) return 'success-soft';
  return 'amber-soft';
}
